// extracted by mini-css-extract-plugin
export default {"mask":"modal_mask__6J2o+","sidebar":"modal_sidebar__x+k4m","menu":"modal_menu__Rszeu","left":"modal_left__j7g7N","addProduct":"modal_addProduct__lLcHf"};